import React from "react";
import PropTypes from "prop-types";
import DispatchModalList from "./DispatchModalList";

const DispatchEmployeesList = ({
  employees,
  handleUpdateModalState,
  selectedEmployees,
  occupiedEmployees
}) => {
  const columns = [
    { selector: "name", title: "Ouvriers", type: "string" },
    { selector: "employee_number", title: "No", type: "number" }
  ];

  const MAX_EMPLOYEE = 18;

  function handleItemClick(item) {
    let newEmployees = [...selectedEmployees];
    if (selectedEmployees.find(employeeID => employeeID === item.id)) {
      newEmployees = newEmployees.filter(employeeID => employeeID !== item.id);
    } else if (newEmployees.length < MAX_EMPLOYEE) {
      newEmployees.push(item.id);
    }

    handleUpdateModalState({ employees: newEmployees });
  }

  return (
    <DispatchModalList
      data={employees}
      selected={selectedEmployees}
      highlighted={occupiedEmployees}
      columns={columns}
      onClick={handleItemClick}
    />
  );
};

DispatchEmployeesList.propTypes = {
  employees: PropTypes.array,
  handleUpdateModalState: PropTypes.func,
  selectedEmployees: PropTypes.array
};

export default DispatchEmployeesList;
